import {
  Box,
  List,
  ListItemText,
  ListItem,
  Typography,
  ListItemIcon,
  makeStyles,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CardMedia,
} from "@material-ui/core";

import RoomIcon from "@material-ui/icons/Room";

import { useHistory } from "react-router-dom";

import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import PaymentIcon from "@material-ui/icons/Payment";
import AccountTreeIcon from "@material-ui/icons/AccountTree";

import CategoryIcon from "../../assets/icons/categories.png";
import TransactionIcon from "../../assets/icons/transactionhistory.png";
import UsersIcon from "../../assets/icons/users.png";
import PasswordIcon from "../../assets/icons/password.png";
import OffersIcon from "../../assets/icons/offers.png";
import ConfigIcon from "../../assets/icons/config.png";
import SFBreadcrumbs from "../../components/SfBreadcrumbs";
import LayoutContainer from "./components/LayoutContainer";
import { useTranslate } from "ra-core";
const useStyles = makeStyles((theme) => ({
  even: {
    backgroundColor: theme.pureWhite,
    borderBottomWidth: "thin",
    borderBottomColor: "#ffefef",
    borderBottomStyle: "inset",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  accordion: {
    borderTopStyle: "none",
    borderBottomWidth: "thin",
    borderBottomColor: theme.lightGray,
    // borderBottomStyle: "inset",
    backgroundColor: theme.pureWhite,
  },
  accordionContent: {
    display: "grid",
    gridTemplateColumns: "24px auto 40px",
    alignItems: "center",
  },
  collapseItem: {
    marginLeft: 0,
    padding: 0,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  accordionDetail: {
    backgroundColor: theme.lightGray,
    display: "grid",
    gridTemplateColumns: "100%",
  },
  subMenu: {
    backgroundColor: "transparent",
  },

  paper: {
    marginLeft: 100,
    marginRight: 100,
    marginTop: 40,
    borderRadius:"10px"
  },
  itemText: {
    fontSize: 24,
    marginLeft: 10,
    fontWeight: 700,
    color: theme.darkGray,
  },
  itemIcon: {
    width: 24,
    height: 24,
    color: theme.orange,
  },
  submenuItemText: {
    fontSize: 20,

    color: theme.black,
  },
  marginLeft: {
    marginLeft: 60,
  },
  accordionMarginLeft: {
    marginLeft: 42,
  },
}));

const ManagementView = () => {
  const history = useHistory();
  const classes = useStyles();
  const translate = useTranslate();
  const menu = [
    {
      name: "Branches",
      element: <RoomIcon className={classes.itemIcon} />,
      onClick: () => history.push("/merchant-branches"),
    },
    {
      name: "Users & Roles",
      element: <CardMedia image={UsersIcon} className={classes.itemIcon} />,
      subMenu: [
        {
          name: "Users",

          onClick: () => history.push("/merchant-users"),
        },
        {
          name: "Roles",

          onClick: () => history.push("/merchant-roles"),
        },
      ],
    },
    {
      name: "Categories & Product",
      element: <CardMedia image={CategoryIcon} className={classes.itemIcon} />,
      subMenu: [
        {
          name: "Categories",

          onClick: () => history.push("/product-categories"),
        },
        {
          name: "Sub-categories",

          onClick: () => history.push("/product-sub-categories"),
        },
        {
          name: "Products",

          onClick: () => history.push("/products"),
        },
      ],
    },

    {
      name: "Transaction History",
      element: (
        <CardMedia image={TransactionIcon} className={classes.itemIcon} />
      ),
      onClick: () => history.push("/transactions"),
    },
    {
      name: "Payment methods",
      element: <PaymentIcon className={classes.itemIcon} />,
      onClick: () => history.push("/payment-channels"),
    },
    {
      name: "Promotions & Tiers",
      element: <CardMedia image={OffersIcon} className={classes.itemIcon} />,
      subMenu: [
        {
          name: "Tiers",

          onClick: () => history.push("/member-tiers"),
        },

        {
          name: "Discount & Special Offers",
          element: <AccountTreeIcon className={classes.itemIcon} />,
          onClick: () => history.push("/offers"),
        },
      ],
    },

    /** 
    {
      name: "Import stock",
      element: <AccountTreeIcon className={classes.itemIcon} />,
      onClick: () => history.push("/stock-import"),
    },
    {
      name: "Stocks",
      element: <AccountTreeIcon className={classes.itemIcon} />,
      onClick: () => history.push("/stock/product"),
    },
    {
      name: "Supplier",
      element: <AccountTreeIcon className={classes.itemIcon} />,
      onClick: () => history.push("/suppliers"),
    },
    {
      name: "Locations",
      element: <AccountTreeIcon className={classes.itemIcon} />,
      onClick: () => history.push("/locations"),
    },*/ {
      name: "Configuration",
      element: <CardMedia image={ConfigIcon} className={classes.itemIcon} />,
      onClick: () => history.push("/management/setting"),
    },
    // {
    //   name: "Change password",
    //   element: <CardMedia image={PasswordIcon} className={classes.itemIcon} />,
    //   onClick: () => history.push("/change-password"),
    // },
    {
      name: "Profile & Change password",
      element: <CardMedia image={PasswordIcon} className={classes.itemIcon} />,
      onClick: () => history.push("/management/profile"),
    },
  ];
  return (
    <LayoutContainer>
      <Box marginTop={5} width={"100%"}>
        <SFBreadcrumbs path="/Management" />
        <Typography align="center" variant="h4">
          {translate("ra.text.settingsTitle")}
        </Typography>
        <Paper className={classes.paper}>
          <List component="nav">
            {menu.map((item, index) => {
              if (!item.subMenu)
                return (
                  <ListItem
                    button
                    onClick={item.onClick}
                    className={classes.even}
                  >
                    <ListItemIcon style={{ pointerEvents: "none" }}>
                      {item.element}
                    </ListItemIcon>
                    <ListItemText
                      style={{ pointerEvents: "none" }}
                      primary={item.name}
                      classes={{ primary: classes.itemText }}
                    />
                  </ListItem>
                );
              return (
                <Accordion style={{margin:0}}>
                  <AccordionSummary
                    classes={{
                      root: classes.accordion,
                      content: classes.accordionContent,
                    }}
                  >
                    {item.element}
                    <Typography
                      className={[
                        classes.itemText,
                        classes.accordionMarginLeft,
                      ]}
                    >
                      {item.name}
                    </Typography>
                    <ArrowDropDownIcon />
                    {/* <ListItemIcon
                      style={{ pointerEvents: "none" }}
                    ></ListItemIcon>
                    <ListItemText
                      style={{ pointerEvents: "none" }}
                      primary={item.name}
                      classes={{ primary: classes.itemText }}
                    />
                    <ArrowDropDownIcon /> */}
                  </AccordionSummary>
                  <AccordionDetails className={classes.accordionDetail}>
                    {item.subMenu.map((sub) => (
                      <ListItem
                        button
                        onClick={sub.onClick}
                        className={[classes.even, classes.subMenu]}
                      >
                        <ListItemText
                          primary={sub.name}
                          classes={{
                            root: classes.marginLeft,
                            primary: classes.subMenuItemText,
                          }}
                        />
                      </ListItem>
                    ))}
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </List>
        </Paper>
      </Box>
    </LayoutContainer>
  );
};

export default ManagementView;
